import type { MetricKey } from '@nest-recruit/shared';
import type { Tone } from '../../components/Tone';

// On a page of mixed figures each card wears the colour of the part of hiring it measures
// (DECISIONS-LOG "Colour per section": section colour + topic cards), so a report reads as
// many colours, not one. A Record, so a metric added to METRIC_KEYS without a colour fails
// the type check.
export const METRIC_TONES: Readonly<Record<MetricKey, Tone>> = {
  open_requisitions: 'requisition',
  requisition_age: 'requisition',
  active_requisitions: 'requisition',
  requisitions_raised: 'requisition',
  approval_latency: 'requisition',
  cancelled_after_start: 'requisition',
  sla_breaches: 'requisition',
  jobs_by_stage: 'job',
  time_to_fill: 'job',
  time_to_fill_index: 'job',
  headcount_forecast: 'organisation',
  funnel: 'screening',
  conversion: 'screening',
  days_in_stage: 'screening',
  drop_off: 'screening',
  process_withdrawals: 'screening',
  source_effectiveness: 'screening',
  source_mix: 'screening',
  pool_sourced: 'screening',
  screening_speed: 'screening',
  recruiter_lag: 'screening',
  screen_to_interview: 'interview',
  interview_to_offer: 'interview',
  decision_latency: 'interview',
  scorecard_lag: 'interview',
  panelist_no_shows: 'interview',
  panelist_interviews: 'interview',
  reschedules_initiated: 'interview',
  severity_index: 'interview',
  hires: 'offer',
  cost_per_hire: 'offer',
  offers: 'offer',
  offer_acceptance: 'offer',
  negotiation_rounds: 'offer',
  joining_rate: 'offer',
  offer_to_join: 'offer',
  overdue_follow_ups: 'tasks',
  overrides: 'admin',
};
